import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-noise w-full max-w-full overflow-x-visible">
      <Header />
      <main className="flex-grow w-full max-w-full overflow-x-visible">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout; 